"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollAreaStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const ScrollAreaStyled = (0, _styled.default)("div")`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0; // allow it to be less than the height of its children
    max-height: 100%;
    position: relative; // for keyline positioning
`;
exports.ScrollAreaStyled = ScrollAreaStyled;
//# sourceMappingURL=ScrollAreaStyled.js.map